import { ArrowUpRight, Phone, Mail } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_d0fa56b4-4a70-4afa-aa14-c29f8806cac4/artifacts/uhdosw09_image.png";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid={LANDING.hero}
      className="relative bg-white"
    >
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 lg:px-12 pt-14 md:pt-20 pb-20 md:pb-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* LEFT — portrait */}
          <div className="relative anim-fade-up order-2 lg:order-1">
            <div className="relative max-w-[480px] mx-auto lg:mx-0">
              {/* yellow offset block */}
              <div className="absolute -top-4 -left-4 w-full h-full bg-[#FFE512] rounded-sm -z-10" />

              <div className="img-zoom relative aspect-[4/5] rounded-sm overflow-hidden bg-[#F4F2EC]">
                <img
                  data-testid={LANDING.heroPortrait}
                  src={PORTRAIT}
                  alt="James Townsend — Licensee Salesperson, Mount Maunganui &amp; Papamoa"
                  className="w-full h-full object-cover"
                  loading="eager"
                />
              </div>
            </div>
          </div>

          {/* RIGHT — info */}
          <div className="order-1 lg:order-2 anim-fade-up">
            <div className="inline-flex items-center gap-2 mb-6">
              <span className="block w-8 h-[2px] bg-[#FFE512]" />
              <span className="overline">Mount Maunganui · Papamoa</span>
            </div>

            <h1
              data-testid={LANDING.heroH1}
              className="text-[36px] leading-[1.1] tracking-[-0.015em] text-[#0E0E0E]"
              style={{ fontFamily: "'Playfair Display', Lato, sans-serif", fontWeight: 700 }}
            >
              James Townsend.
            </h1>

            <div className="mt-5 flex items-center gap-3">
              <span className="block w-6 h-px bg-[#0E0E0E]" />
              <p className="font-sans-tight text-[13px] uppercase tracking-[0.22em] font-semibold text-[#0E0E0E]">
                Licensee Salesperson
              </p>
            </div>

            <p className="mt-8 max-w-xl text-[17px] text-[#4A4A4A] leading-[1.7] anim-fade-up anim-d1">
              A Bay of Plenty real estate agent with two decades in business and a
              lifetime in property. Energy, passion and straight-up advice every
              step of the way.
            </p>

            {/* CTAs */}
            <div className="mt-9 flex flex-wrap items-center gap-3 anim-fade-up anim-d2">
              <a
                href="#contact"
                data-testid={LANDING.heroAppraisalBtn}
                className="btn btn-yellow"
              >
                Get sales appraisal
                <ArrowUpRight className="w-4 h-4" />
              </a>
              <a
                href="#contact"
                className="btn btn-ghost"
              >
                Contact James
              </a>
            </div>

            {/* Phone / Email block */}
            <div className="mt-10 pt-7 border-t border-[#E6E3D9] grid grid-cols-1 sm:grid-cols-2 gap-5">
              <a
                href="tel:+64272141475"
                data-testid={LANDING.heroCallBtn}
                className="flex items-start gap-3 group"
              >
                <span className="w-10 h-10 rounded-sm bg-[#FFE512] text-[#0E0E0E] flex items-center justify-center shrink-0">
                  <Phone className="w-4 h-4" />
                </span>
                <div>
                  <div className="text-[10.5px] uppercase tracking-[0.2em] font-semibold text-[#888880]">Mobile</div>
                  <div className="mt-1 font-sans-tight text-[15px] font-normal text-[#0E0E0E] group-hover:text-[#2B2B2B] transition-colors whitespace-nowrap">
                    +64 27 214 1475
                  </div>
                </div>
              </a>
              <a
                href="mailto:james@jamestownsendrealestate.co.nz"
                className="flex items-start gap-3 group min-w-0"
              >
                <span className="w-10 h-10 rounded-sm bg-[#FFE512] text-[#0E0E0E] flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4" />
                </span>
                <div className="min-w-0">
                  <div className="text-[10.5px] uppercase tracking-[0.2em] font-semibold text-[#888880]">Email</div>
                  <div className="mt-1 font-sans-tight text-[15px] font-normal text-[#0E0E0E] group-hover:text-[#2B2B2B] transition-colors whitespace-nowrap">
                    james@jamestownsendrealestate.co.nz
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
